/**
 * API client for allocation endpoints
 */

import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';

/**
 * Admin cancel any allocation, including variations.
 *
 * @param allocationId - The unique identifier of the allocation to cancel
 * @param cancellationNotes - Optional notes for the cancellation
 */
export async function adminCancelAllocation(
  allocationId: string,
  cancellationNotes?: string
): Promise<void> {
  unwrap(
    await api.legacy.POST('/api/v1/allocations/{allocationId}/admin-cancel', {
      params: { path: { allocationId } },
      body: { cancellationNotes: cancellationNotes ?? null },
    })
  );
}

export async function getAllocationRejectionReasons(signal?: AbortSignal) {
  const response = unwrap(
    await api.portalGateway.GET('/portal/v1/rejection-reasons', { signal })
  );
  return response.rejectionReasons;
}

export async function approveAllocation(
  allocationId: string,
  approvalNotes: string
): Promise<void> {
  unwrap(
    await api.legacy.POST('/api/mobile/v1/approvals/{allocationId}/approve', {
      params: { path: { allocationId } },
      body: { approvalNotes: approvalNotes.trim() || null },
    })
  );
}

export async function rejectAllocation(
  allocationId: string,
  rejectionReasonSlug: string,
  rejectionNotes: string
): Promise<void> {
  unwrap(
    await api.legacy.POST('/api/mobile/v1/approvals/{allocationId}/reject', {
      params: { path: { allocationId } },
      body: { rejectionReasonSlug, rejectionNotes: rejectionNotes.trim() },
    })
  );
}

export async function cancelLabourAllocation(
  allocationId: string,
  cancellationNotes: string
): Promise<void> {
  unwrap(
    await api.pricework.POST(
      '/pricework/api/v1/allocations/{allocationId}/cancel',
      {
        params: { path: { allocationId } },
        body: { cancellationNotes: cancellationNotes.trim() || null },
      }
    )
  );
}

export async function cancelAllocation(
  allocationId: string,
  cancellationNotes: string,
  isVariation: boolean
): Promise<void> {
  if (isVariation) {
    return adminCancelAllocation(allocationId, cancellationNotes);
  }

  return cancelLabourAllocation(allocationId, cancellationNotes);
}
